
if (document.getElementById("vue-publications")) {
  new Vue({
    mixins: [baseMixin, eventHubMixin, apiMixin],
    el: '#vue-publications',
    data: {
      publications: [],
      posts_per_page: 4,
      loading: true,
      total: 0,
    },
    created() { },
    mounted() {
      this.getPublications();
    },
    computed: {
      hasMore() {
        return this.total > this.publications.length;
      }
    },
    methods: {
      getPublications() {
        this.loading = true;

        let data = {
          posts_per_page: this.posts_per_page,
          offset: this.publications.length
        };

        this.get('sophia/v1/publications', data)
          .then(response => {
            const data = response.data;
            setTimeout(() => {
              this.publications = this.publications.concat(data.publications);
              this.loading = false;
              this.total = data.total;
            }, 1000)

          }
          );
      },
    },
  })
}